import React from 'react';
import Box from '@Atoms/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ScoreBar from './ScoreBar';

interface HierarchyRowProps {
  id: string;
  name: string;
  studentCount: number;
  scorePercentage: number;
  isExpanded: boolean;
  onToggle: () => void;
  leftMargin?: number;
  iconSize?: string;
  fontSize?: string;
  barColor?: string;
  barHeight?: number;
  showBorder?: boolean;
}

const HierarchyRow: React.FC<HierarchyRowProps> = ({
  name,
  studentCount,
  scorePercentage,
  isExpanded,
  onToggle,
  leftMargin = 0,
  iconSize = '1rem',
  fontSize = '0.875rem',
  barColor = 'success.main',
  barHeight = 20,
  showBorder = true,
}) => (
  <Box
    sx={{
      cursor: 'pointer',
      '&:hover': { bgcolor: 'action.hover' },
      transition: 'all 0.2s',
      ...(showBorder && { borderTop: 1, borderColor: 'divider' }),
    }}
    onClick={onToggle}
  >
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gap: 2,
        px: 3,
        py: 1.5,
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          gridColumn: 'span 5',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          ml: leftMargin,
        }}
      >
        <ExpandMoreIcon
          sx={{
            fontSize: iconSize,
            transition: 'transform 0.2s',
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            flexShrink: 0,
          }}
        />
        <Box
          component="span"
          sx={{
            fontSize,
            fontWeight: 500,
            color: 'text.primary',
          }}
        >
          {name}
        </Box>
      </Box>
      <Box
        sx={{
          gridColumn: 'span 2',
          textAlign: 'center',
          fontSize: '0.75rem',
          color: 'text.secondary',
        }}
      >
        {studentCount}
      </Box>
      <Box sx={{ gridColumn: 'span 5' }}>
        <ScoreBar percentage={scorePercentage} color={barColor} height={barHeight} />
      </Box>
    </Box>
  </Box>
);

export default HierarchyRow;
